import { render, staticRenderFns } from "./gptOil.vue?vue&type=template&id=1156e054&scoped=true"
import script from "./gptOil.vue?vue&type=script&lang=js"
export * from "./gptOil.vue?vue&type=script&lang=js"
import style0 from "./gptOil.vue?vue&type=style&index=0&id=1156e054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156e054",
  null
  
)

export default component.exports